import { render } from "./ListingV2.vue?vue&type=template&id=6ddfcb89&scoped=true"
import script from "./ListingV2.vue?vue&type=script&lang=js"
export * from "./ListingV2.vue?vue&type=script&lang=js"

import "./ListingV2.vue?vue&type=style&index=0&id=6ddfcb89&lang=css"
import "./ListingV2.vue?vue&type=style&index=1&id=6ddfcb89&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddfcb89"]])

export default __exports__